import { jwtDecode } from 'jwt-decode';
export const TOKEN_KEY = 'token';
export const getAuthToken = () => {
    return localStorage.getItem(TOKEN_KEY);
};
export const setAuthToken = (token) => {
    if (token) {
        localStorage.setItem(TOKEN_KEY, token);
    }
};
export const clearAuthToken = () => {
    localStorage.removeItem(TOKEN_KEY);
};
export const REFRESH_KEY = 'refresh_token';
export const getRefreshToken = () => {
    return localStorage.getItem(REFRESH_KEY);
};
export const setRefreshToken = (token) => {
    if (token) {
        localStorage.setItem(REFRESH_KEY, token);
    }
};
export const clearRefreshToken = () => {
    localStorage.removeItem(REFRESH_KEY);
};
export const decodeToken = (token) => {
    try {
        return jwtDecode(token);
    }
    catch {
        return null;
    }
};
